export const TMDnDItemTypes = {
	TAB: 'tab',
	CHANNEL: 'channel',
  }